// Catalog.ID Client — Recovery Sheet Verification API
// ============================================================================
// The single anonymous call behind the /recovery page (Recovery Kit Addendum
// §6.4). A custodian holding one sheet asks the node the ONE question the
// sheet cannot answer about itself: is this recovery set still the account's
// current kit?
//
// ONLY the recovery-set id is transmitted. The share bytes, the per-set
// verification key and the payload MAC never leave the device — verification
// is a local check plus a currency question, and a page that sent more than
// the id would be sending material the custodian was trusted with.
//
// The answer is binary (§6.4 / product decision): "current" names the account,
// and an unknown id, a superseded id and a terminated account's id are all the
// same "not_current". No session is involved; the caller has no account.

import { api } from './client';
import type { VerifyAnswer } from '../auth/recovery-verify';

export type { VerifyAnswer };

/**
 * Ask the node whether `recoverySetId` is some account's current kit.
 *
 * @param recoverySetId Canonical UUID string, taken from a scanned sheet's
 *                      payload — never typed by hand.
 * @throws ApiError on a rejected shape (400) or rate limit (429); the caller
 *         treats an unreachable node as "unchecked" rather than a verdict.
 */
export async function verifyRecoverySet(recoverySetId: string): Promise<VerifyAnswer> {
    return api.post<VerifyAnswer>('/api/recoverykit/verify', { recoverySetId });
}
